<template>
  <div>
    <div class="wechat-notice">
      <img
        src="@/assets/img/activity/wechatIcon.png"
        alt=""
        @click="openWechat"
      />
    </div>
    <van-popup
      v-model="isShow"
      class="sub-popup"
      get-container="body"
      :close-on-click-overlay="false"
    >
      <img
        class="icon_close"
        src="@/assets/img/activity/icon_close.png"
        alt=""
        @click="isShow = false"
      />
      <div>开启微信通知，最新职位通知</div>
      <div>第一时间为你送达！</div>
      <img class="sub_tips" src="@/assets/img/activity/sub_tip.png" alt=/>
      <div class="sub_btn" @click="openAppWechat">立即开启</div>
    </van-popup>
  </div>
</template>

<script>
// import wx from "weixin-js-sdk";
import { Popup } from "vant";
export default {
  name: "WechatNotice",
  components: {
    [Popup.name]: Popup,
  },
  props: {
    wechatStatus: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isLogin() {
      return this.$store.getters.isLogin;
    },
    isApp() {
      return (
        this.$store.getters.platform === "51jobApp" ||
        this.$store.getters.platform === "yjsApp"
      );
    },
    isWeChat() {
      return this.$store.getters.appType === "weixin";
    },
    platform() {
      return this.$store.getters.platform;
    },
    isMiniProgram() {
      return (
        this.$store.getters.platform === "51jobWX" ||
        this.$store.getters.platform === "yjsWX"
      );
    },
  },
  data() {
    return {
      isShow: false,
    };
  },
  methods: {
    openWechat() {
      this.$sensors.track("$WebClick", {
        $element_id: "sensor_bcop_top_follow",
      });
      this.$router.push({ path: "/scanCode" });
    },
    // openWechat() {
    //   this.$sensors.track("$WebClick", {
    //     $element_id: "sensor_bcop_top_follow",
    //   });
    //   if (!this.isApp) {
    //     if (this.isWeChat) {
    //       this.$router.push({
    //         path: "/scanCode",
    //       });
    //     } else if (this.isMiniProgram) {

    //       // 51小程序内
    //       if (this.platform === '51jobWX') {
    //         // weixin 内跳转方法
    //         wx.miniProgram.navigateTo({
    //           url: '/pages/my/jumpurl/jumpurl?id=7',
    //         });
    //         return;
    //       }
    //       // 应届生小程序内
    //       if (this.platform === 'yjsWX') {
    //         // weixin 内跳转方法
    //         wx.miniProgram.navigateTo({
    //           url: '/pages/outweb/index?linkurl=https%3A//young.yingjiesheng.com/m/guide%3Ftype%3D1',
    //         });
    //         return;
    //       }
    //     } else {
    //       this.$router.push({
    //         path: "/scanCode",
    //       });
    //     }
    //   } else {
    //     this.isShow = true;
    //   }
    // },
    openAppWechat() {
      if (this.platform == "yjsApp") {
        window.location.href =
          "yingjiesheng://home/openMessageAndSystemSettingPage";
      } else {
        if (this.$store.getters.device == "harmonyApp") {
          window.harmony.jsAppBridgeOpenScheme(JSON.stringify({
            url: "qiancheng://home/show_system_settings"
          }));
        } else {
          window.location.href = "qiancheng://home/show_system_settings";
        }
      }

      this.isShow = false;
    },
  },
};
</script>

<style lang="less" scoped>
.wechat-notice {
  img {
    width: 26px;
    height: 26px;
  }
}
.sub-popup {
  position: fixed;
  height: 316px;
  overflow-y: visible;
  width: 311px;
  background: linear-gradient(180deg, #fffce1 0%, #ffffff 100%);
  border-radius: 16px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 18px;
  color: #000000;
  line-height: 25px;
  text-align: center;
  font-style: normal;
  padding-top: 44px;
  .icon_close {
    position: absolute;
    top: 14px;
    left: 15px;
    width: 20px;
    height: 20px;
  }
  .sub_tips {
    width: 100%;
    height: 148px;
    margin-top: 18px;
  }
  .sub_btn {
    width: 200px;
    height: 44px;
    background: linear-gradient(180deg, #ffb240 0%, #ff6300 100%);
    box-shadow: inset 0px 3px 9px 0px #ff6906;
    border-radius: 22px;
    margin: auto;
    margin-top: -20px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: #ffffff;
    line-height: 44px;
    text-align: center;
    font-style: normal;
  }
}
</style>
